import React from 'react';
import HeaderOne from '../Components/Header/HeaderOne';
import FoodDeliveryInTrain from '../Components/FoodDeliveryInTrain/FoodDeliveryInTrain'; // renamed import
import Footer from '../Components/Footer/FooterOne';
import { Helmet } from "react-helmet-async";   // ✅ correct import

function FoodDeliveryInTrainPage() { // renamed component
    return (
        <>

        <Helmet>
                <title>Order Pure Veg Train Food at Coimbatore Junction (CBE) | Tickling Tummy</title>
                <meta name="description" content="Tickling Tummy is a premier homemade vegetarian food service in Coimbatore, delivering fresh, hygienic home-cooked meals directly to your seat at Coimbatore Junction (CBE)." />
                <meta name="keywords" content="Train food delivery Coimbatore, Order veg food on train, Coimbatore Junction CBE meals, Train catering Coimbatore, Homemade train meals Coimbatore" />
                <link rel="canonical" href="https://ticklingtummy.com/food-delivery-in-train" />
                
                {/* Open Graph Tags */}
                <meta property="og:title" content="Order Pure Veg Train Food at Coimbatore Junction (CBE) | Tickling Tummy" />
                <meta property="og:description" content="Tickling Tummy is a premier homemade vegetarian food service in Coimbatore, delivering fresh, hygienic home-cooked meals directly to your seat at Coimbatore Junction (CBE)." />
                <meta property="og:image" content="https://ticklingtummy.com/assets/images/train-food-delivery-coimbatore.jpg" />
                <meta property="og:url" content="https://ticklingtummy.com/food-delivery-in-train" />
                <meta property="og:type" content="website" />
                
                {/* Twitter Card Tags */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Order Pure Veg Train Food at Coimbatore Junction (CBE) | Tickling Tummy" />
                <meta name="twitter:description" content="Tickling Tummy is a premier homemade vegetarian food service in Coimbatore, delivering fresh, hygienic home-cooked meals directly to your seat at Coimbatore Junction (CBE)." />
                <meta name="twitter:image" content="https://ticklingtummy.com/assets/images/train-food-delivery-coimbatore.jpg" />
            </Helmet>

        <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
  {
    "@type": "ListItem",
    "position": 1,
    "name": "Home",
    "item": "https://ticklingtummy.com"
  },
  {
    "@type": "ListItem",
    "position": 2,
    "name": "Train Food Delivery",
    "item": "https://ticklingtummy.com/food-delivery-in-train"
  }
]
        }, null, 2)}
        </script>

            <HeaderOne />
            <FoodDeliveryInTrain />
            <Footer />
        </>
    );
}

export default FoodDeliveryInTrainPage;
